module.exports = __webpack_public_path__ + "img/Profile_1.4e5105e8.jpg";